import { useAtom } from 'jotai';
import { resetQuestStoreAtom } from '../devhubSingleQuestStore.atoms';

export function useResetQuestStore(): [undefined, () => void] {
	const [, set] = useAtom(resetQuestStoreAtom);
	return [, set];
}
